var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "container" } },
    [
      _c(_vm.whichSearchWidget, { tag: "component" }),
      _c(_vm.mainComponent, { tag: "component" }),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showHelp,
                expression: "showHelp"
              }
            ],
            staticClass: "ui segment ui segment",
            attrs: { id: "helpbox" }
          },
          [
            _c("h3", { staticStyle: { "margin-left": "10px" } }, [
              _vm._v("MyStreetSF")
            ]),
            _c(
              "div",
              {
                staticClass: "mybox",
                staticStyle: { "background-color": "white" }
              },
              [
                _c("hr"),
                _c(
                  "div",
                  {
                    staticClass: "myotherbox",
                    staticStyle: { padding: "20px 15px", "margin-top": "-10px" }
                  },
                  [
                    _c("div", { staticClass: "scrollhelperbox" }, [
                      _c("p", [
                        _vm._v(
                          "This map shows transportation projects funded by the Transportation Authority or which we help oversee in our role as the Congestion Management Agency for San Francisco."
                        )
                      ]),
                      _c(
                        "h3",
                        {
                          staticClass: "black",
                          staticStyle: { "margin-top": "10px" }
                        },
                        [_vm._v("How to use this map")]
                      ),
                      _c("hr", { staticStyle: { "margin-bottom": "5px" } }),
                      _c("ul", [
                        _c("li", [
                          _c("b", [_vm._v("Click any project")]),
                          _vm._v("\nfor a brief project description.")
                        ]),
                        _c("li", [
                          _c("b", [_vm._v("Use filters")]),
                          _vm._v("\nto narrow by status, category, and more.")
                        ]),
                        _c("li", [
                          _c("b", [_vm._v("Use the search bar")]),
                          _vm._v(
                            "\nto find projects by project name, location, keyword, and project type."
                          )
                        ]),
                        _c("li", [
                          _c("b", [_vm._v("Click the citywide projects link")]),
                          _vm._v(
                            "\nfor a gallery of projects that are not location-specific so they don’t appear on the map (e.g. Muni vehicle procurements, paratransit operations)."
                          )
                        ]),
                        _c("li", [
                          _c("b", [_vm._v("Use the Map Layers icon")]),
                          _vm._v(
                            "\nto overlay the High Injury Network, Supervisorial Districts, and Equity Priority Communities."
                          )
                        ]),
                        _c("li", [
                          _c("b", [_vm._v("Download map data")]),
                          _vm._v(
                            "\nto get information for specific projects or the entire data set in a .CSV format. For a subset of data, apply the filters you want (e.g. Underway Transit), click the Download button, then click “Filtered Projects”."
                          )
                        ])
                      ]),
                      _c("p", [
                        _vm._v(
                          "Projects that are underway are updated on a quarterly basis and new projects are added upon approval. We cannot guarantee the accuracy or completeness of the information shown on the map. If you have questions or comments, please contact us at "
                        ),
                        _c(
                          "a",
                          { attrs: { href: "mailto:mystreetsf@sfcta.org" } },
                          [_vm._v("mystreetsf@sfcta.org")]
                        ),
                        _vm._v(".")
                      ])
                    ]),
                    _c("div", { staticStyle: { "margin-top": "15px" } }, [
                      _c(
                        "button",
                        {
                          staticClass: "small ui violet button",
                          on: { click: _vm.clickedToggleHelp }
                        },
                        [_vm._v("OK, GOT IT")]
                      )
                    ])
                  ]
                )
              ]
            )
          ]
        )
      ]),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showDownload,
                expression: "showDownload"
              }
            ],
            staticClass: "ui segment ui segment",
            attrs: { id: "downloadbox" }
          },
          [
            _c("h3", { staticStyle: { "margin-left": "10px" } }, [
              _c(
                "button",
                {
                  staticClass: "ui tiny compact pink icon button",
                  staticStyle: { float: "right" },
                  on: { click: _vm.clickedCloseDownload }
                },
                [_c("i", { staticClass: "close icon" })]
              ),
              _vm._v("Download Data")
            ]),
            _c(
              "div",
              {
                staticClass: "mybox",
                staticStyle: { "background-color": "white" }
              },
              [
                _c("hr"),
                _c(
                  "div",
                  {
                    staticClass: "myotherbox",
                    staticStyle: { padding: "25px 25px" }
                  },
                  [
                    _c("p", [
                      _vm._v(
                        "The data powering this site can be downloaded in .CSV format and opened in any spreadsheet software such as Microsoft Excel."
                      )
                    ]),
                    _c("br"),
                    _c("p", [
                      _vm._v(
                        "You can download data just for the projects you've selected, or you can download the entire dataset."
                      )
                    ]),
                    _c("br"),
                    _c(
                      "h3",
                      {
                        staticClass: "black",
                        staticStyle: { "margin-bottom": "10px" }
                      },
                      [_vm._v("Choose what you would like to download:")]
                    ),
                    _c("div", { staticClass: "download-buttons ui buttons" }, [
                      _c(
                        "button",
                        {
                          staticClass: "ui yellow button",
                          attrs: { id: "dl-selected-project" },
                          on: {
                            click: function($event) {
                              return _vm.downloadData((_vm.filtered = true))
                            }
                          }
                        },
                        [_vm._v("Filtered Projects")]
                      ),
                      _c("div", { staticClass: "or" }),
                      _c(
                        "button",
                        {
                          staticClass: "ui violet button",
                          on: {
                            click: function($event) {
                              return _vm.downloadData((_vm.filtered = false))
                            }
                          }
                        },
                        [_vm._v("Everything")]
                      )
                    ])
                  ]
                )
              ]
            )
          ]
        )
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.nearbyProjects.length > 0,
              expression: "nearbyProjects.length>0"
            }
          ],
          staticClass: "ui segment ui segment",
          style: _vm.popupLocation,
          attrs: { id: "nearbyprojects" }
        },
        [
          _vm.nearbyProjects.length > 0
            ? _c(
                "div",
                {
                  staticClass: "thing",
                  on: {
                    click: function($event) {
                      return _vm.clickedNearbyProject(0)
                    },
                    mouseover: function($event) {
                      return _vm.hoverAboveNearbyItem(0)
                    }
                  }
                },
                [
                  _c("h5", { staticClass: "nearby-title" }, [
                    _c(
                      "button",
                      {
                        staticClass: "ui tiny compact pink icon button",
                        staticStyle: { float: "right" },
                        on: { click: _vm.clickedCloseNearby }
                      },
                      [_c("i", { staticClass: "close icon" })]
                    ),
                    _vm._v(
                      _vm._s(_vm.trimmedProjectName(_vm.nearbyProjects[0]))
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm.nearbyProjects.length > 1
            ? _c(
                "div",
                { staticClass: "other-projects" },
                [
                  _c(
                    "h5",
                    {
                      staticClass: "black",
                      staticStyle: {
                        "font-size": "11px",
                        "margin-left": "5px",
                        "padding-top": "5px"
                      }
                    },
                    [_vm._v("ALSO NEARBY:")]
                  ),
                  _c("hr", { staticStyle: { margin: "0px 8px 5px 5px" } }),
                  _vm._l(_vm.nearbyProjects, function(prj, index) {
                    return _c(
                      "div",
                      {
                        staticClass: "nearby-project-row",
                        on: {
                          click: function($event) {
                            return _vm.clickedNearbyProject(index)
                          },
                          mouseover: function($event) {
                            return _vm.hoverAboveNearbyItem(index)
                          }
                        }
                      },
                      [
                        index > 0
                          ? _c("h5", { staticClass: "nearby-row" }, [
                              _vm._v(_vm._s(_vm.trimmedProjectName(prj)))
                            ])
                          : _vm._e()
                      ]
                    )
                  })
                ],
                2
              )
            : _vm._e()
        ]
      ),
      _c(
        "div",
        {
          class: { "ie-shrunken": _vm.isPanelHidden },
          attrs: { id: "layer-widgets" }
        },
        [
          _c(
            "button",
            {
              staticClass: "ui tiny grey icon button",
              class: { blue: _vm.showingMainPanel },
              attrs: { "data-tooltip": "Projects" },
              on: { click: _vm.clickedShowMainPanel }
            },
            [_c("i", { staticClass: "list icon" })]
          ),
          _c("br"),
          _c(
            "button",
            {
              staticClass: "ui tiny grey icon button",
              class: { blue: _vm.showingLayerPanel },
              attrs: {
                "data-tooltip": "Map Layers",
                disabled: _vm.is_citywide
              },
              on: { click: _vm.clickedShowLayerSelector }
            },
            [_c("i", { staticClass: "clone outline icon" })]
          ),
          _c("br"),
          _c(
            "button",
            {
              staticClass: "ui icon tiny grey button",
              attrs: { "data-tooltip": "Download map data" },
              on: { click: _vm.clickedDownload }
            },
            [_c("i", { staticClass: "download icon" })]
          ),
          _c("br"),
          _c("br"),
          _c(
            "button",
            {
              staticClass: "ui tiny green icon button",
              attrs: { id: "btn-showhide", "data-tooltip": "Show/Hide Panel" },
              on: { click: _vm.clickedShowHide }
            },
            [
              _c("i", {
                staticClass: "angle double icon",
                class: { left: _vm.isPanelHidden, right: !_vm.isPanelHidden }
              })
            ]
          )
        ]
      ),
      _c("div", { attrs: { id: "layer-widgets-mobile" } }, [
        _c(
          "button",
          {
            staticClass: "nav-button ui small button",
            class: { violet: _vm.showingMainPanel },
            on: { click: _vm.mobileToggleMainPanel }
          },
          [_c("i", { staticClass: "list icon" }), _vm._v("Info")]
        ),
        _c(
          "button",
          {
            staticClass: "nav-button ui small button",
            class: { violet: _vm.showingFilterPanel },
            on: { click: _vm.mobileToggleFilterPanel }
          },
          [_c("i", { staticClass: "filter icon" }), _vm._v("Filters")]
        ),
        _c(
          "button",
          {
            staticClass: "nav-button ui small button",
            class: { violet: _vm.showingLayerPanel },
            on: { click: _vm.mobileToggleLayerSelector }
          },
          [_c("i", { staticClass: "clone outline icon" }), _vm._v("Layers")]
        )
      ]),
      _c("transition", { attrs: { name: "slide" } }, [
        _vm.showingLayerPanel || _vm.isMobile
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "touch",
                    rawName: "v-touch:swipe",
                    value: _vm.swipeHandler,
                    expression: "swipeHandler",
                    arg: "swipe"
                  }
                ],
                staticClass: "panel sidepanel",
                class: {
                  shrunken:
                    _vm.isPanelHidden ||
                    (_vm.isMobile && !_vm.showingLayerPanel)
                }
              },
              [
                _c(
                  "div",
                  { attrs: { id: "preheader" } },
                  [
                    _vm.isMobile
                      ? _c("div", { staticClass: "some-flair" })
                      : _vm._e(),
                    !_vm.isMobile
                      ? _c("div", { staticClass: "product-title" }, [
                          _c("hr"),
                          _c("h3", { staticClass: "apptitle" }, [
                            _vm._v("MyStreetSF")
                          ]),
                          _c("hr")
                        ])
                      : _vm._e(),
                    !_vm.isMobile ? _c("br") : _vm._e(),
                    _c("h2", [_vm._v("MAP LAYERS:")]),
                    _c("p", [
                      _vm._v(
                        "You can add additional geographic data to the map from the options below."
                      )
                    ]),
                    _c("br"),
                    _c("br"),
                    _vm._l(_vm.extraLayers, function(layer) {
                      return _c("div", { staticClass: "layer-selectors" }, [
                        _c("label", [_vm._v(_vm._s(layer.name))]),
                        _c(
                          "button",
                          {
                            staticClass: "ui icon button basic blue circular",
                            staticStyle: {
                              border: "none",
                              "box-shadow": "none !important",
                              "margin-left": "10px"
                            },
                            attrs: { "data-tooltip": layer.help },
                            on: { click: _vm.clickedShowLayerSelector }
                          },
                          [
                            _c("i", {
                              staticClass: "icon question circle outline"
                            })
                          ]
                        ),
                        _c("br"),
                        _c(
                          "div",
                          { staticClass: "ui toggle checkbox layer-selectors" },
                          [
                            _c("input", {
                              attrs: { name: layer.name, type: "checkbox" },
                              domProps: { checked: layer.show },
                              on: {
                                click: function($event) {
                                  return _vm.clickedToggleLayer(layer.tag)
                                }
                              }
                            }),
                            _c("label", [_vm._v(" ")]),
                            _c("br")
                          ]
                        ),
                        _c("br")
                      ])
                    })
                  ],
                  2
                )
              ]
            )
          : _vm._e()
      ]),
      _c("transition", { attrs: { name: "slide" } }, [
        _vm.showingFilterPanel || _vm.isMobile
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "touch",
                    rawName: "v-touch:swipe",
                    value: _vm.swipeHandler,
                    expression: "swipeHandler",
                    arg: "swipe"
                  }
                ],
                staticClass: "panel sidepanel",
                class: {
                  shrunken:
                    _vm.isPanelHidden ||
                    (_vm.isMobile && !_vm.showingFilterPanel)
                }
              },
              [
                _c("div", { staticClass: "some-flair" }),
                _c("div", { staticClass: "information-panel" }, [
                  _c("h2", [_vm._v("FILTERS")]),
                  _c("div", { staticClass: "pickers" }, [
                    _c("h5", [_vm._v("STATUS:")]),
                    _c(
                      "button",
                      {
                        staticClass: "tiny ui grey button",
                        class: {
                          active: _vm.filterUnderway,
                          yellow: _vm.filterUnderway
                        },
                        attrs: { id: "btn-underway" },
                        on: { click: _vm.clickedFilter }
                      },
                      [_vm._v("Underway")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "tiny ui grey button",
                        class: {
                          active: _vm.filterComplete,
                          yellow: _vm.filterComplete
                        },
                        attrs: { id: "btn-complete" },
                        on: { click: _vm.clickedFilter }
                      },
                      [_vm._v("Completed")]
                    ),
                    _c("h5", [_vm._v("CATEGORY:")]),
                    _c(
                      "button",
                      {
                        staticClass: "tiny ui grey button",
                        class: {
                          active: _vm.filterTransit,
                          blue: _vm.filterTransit
                        },
                        attrs: { id: "btn-transit" },
                        on: { click: _vm.clickedFilter }
                      },
                      [_vm._v("Transit")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "tiny ui grey button",
                        class: {
                          active: _vm.filterStreets,
                          green: _vm.filterStreets
                        },
                        attrs: { id: "btn-streets" },
                        on: { click: _vm.clickedFilter }
                      },
                      [_vm._v("Streets")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "tiny ui grey button",
                        class: {
                          active: _vm.filterAreas,
                          yellow: _vm.filterAreas
                        },
                        attrs: { id: "btn-areas" },
                        on: { click: _vm.clickedFilter }
                      },
                      [_vm._v("Plans & Programs")]
                    ),
                    _c("div", { attrs: { id: "dropdowns" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "narrow-dropdown",
                          staticStyle: { float: "left" }
                        },
                        [
                          _c("h5", [_vm._v("DISTRICT:")]),
                          _c(
                            "div",
                            { staticClass: "ui selection fluid dropdown" },
                            [
                              _c("div", { staticClass: "text" }, [
                                _c("div", {}, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.nameOfFilterDistrict(
                                        _vm.filterDistrict
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _c("i", { staticClass: "dropdown icon" }),
                              _c(
                                "div",
                                { staticClass: "menu" },
                                _vm._l(
                                  [-1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                                  function(i) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass: "item",
                                        on: {
                                          click: function($event) {
                                            return _vm.clickedDistrict(i)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.nameOfFilterDistrict(i))
                                        )
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            ]
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "narrow-dropdown",
                          staticStyle: { float: "right" }
                        },
                        [
                          _c("h5", [_vm._v("FUNDING SOURCE:")]),
                          _c(
                            "div",
                            { staticClass: "ui selection fluid dropdown" },
                            [
                              _c("div", { staticClass: "text" }, [
                                _c("div", {}, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.filterFund
                                        ? _vm.filterFund
                                        : "All sources…"
                                    )
                                  )
                                ])
                              ]),
                              _c("i", { staticClass: "dropdown icon" }),
                              _c(
                                "div",
                                { staticClass: "menu" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "item",
                                      attrs: { "data-fund": null },
                                      on: { click: _vm.clickedFunds }
                                    },
                                    [_vm._v("All sources")]
                                  ),
                                  _vm._l(_vm.fundSources, function(fund) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass: "item",
                                        attrs: { "data-fund": fund },
                                        on: { click: _vm.clickedFunds }
                                      },
                                      [_vm._v(_vm._s(fund))]
                                    )
                                  })
                                ],
                                2
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ]
            )
          : _vm._e()
      ]),
      _c("transition", { attrs: { name: "slide" } }, [
        _vm.isMobile
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "touch",
                    rawName: "v-touch:swipe",
                    value: _vm.swipeHandler,
                    expression: "swipeHandler",
                    arg: "swipe"
                  }
                ],
                staticClass: "panel sidepanel",
                class: { shrunken: !_vm.showingMainPanel }
              },
              [
                _c("div", { staticClass: "some-flair" }),
                _c("div", { staticClass: "information-panel" }, [
                  _c("div", { staticClass: "title-thing" }, [
                    _vm.infoUrl
                      ? _c(
                          "button",
                          {
                            staticClass: "ui button small pink compact",
                            staticStyle: {
                              margin: "2px 0px 10px 15px",
                              float: "right"
                            },
                            on: { click: _vm.clickedMoreDetails }
                          },
                          [_vm._v("SHOW DETAILS")]
                        )
                      : _vm._e(),
                    _c("h2", {
                      staticClass: "mobile-squish",
                      class: { noSelection: !_vm.infoUrl },
                      domProps: { innerHTML: _vm._s(_vm.infoTitle) }
                    })
                  ]),
                  _c("p", { staticClass: "mobile-squish" }, [
                    _vm._v(_vm._s(_vm.clippedInfoDetails))
                  ]),
                  !_vm.infoUrl
                    ? _c("h3", { staticStyle: { "text-align": "center" } }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.helptext.PRETEXT) }
                        }),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.helptext.LINK_URL,
                              target: "_blank"
                            }
                          },
                          [
                            _c("span", {
                              staticStyle: { color: "#fc4" },
                              domProps: {
                                innerHTML: _vm._s(_vm.helptext.LINK_TEXT)
                              }
                            })
                          ]
                        )
                      ])
                    : _vm._e(),
                  !_vm.infoUrl
                    ? _c("div", { staticClass: "helpbar" }, [
                        _c("br"),
                        _c(
                          "button",
                          {
                            staticClass:
                              "ui right labeled icon violet tiny button",
                            staticStyle: { padding: "8px 0px" },
                            on: { click: _vm.clickedToggleHelp }
                          },
                          [
                            _c("i", { staticClass: "icon info" }),
                            _vm._v("About this map")
                          ]
                        ),
                        _vm._v("  "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "ui right labeled icon violet tiny button",
                            staticStyle: {
                              padding: "8px 0px",
                              "margin-bottom": "2px"
                            },
                            on: { click: _vm.clickedLearnMore }
                          },
                          [
                            _c("i", { staticClass: "icon right arrow" }),
                            _vm._v("Learn more…")
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              ]
            )
          : _vm._e()
      ]),
      _vm.showingMainPanel && !_vm.isMobile
        ? _c(
            "div",
            {
              staticClass: "panel sidepanel",
              class: { shrunken: _vm.isPanelHidden }
            },
            [
              _c("div", { attrs: { id: "preheader" } }, [
                _c("hr"),
                _vm._m(0),
                _c("div", { staticClass: "helpbar" }, [
                  _c(
                    "button",
                    {
                      staticClass: "ui right labeled icon violet tiny button",
                      staticStyle: { padding: "8px 0px" },
                      on: { click: _vm.clickedToggleHelp }
                    },
                    [
                      _c("i", { staticClass: "icon info" }),
                      _vm._v("About this map")
                    ]
                  ),
                  _vm._v("  "),
                  _c(
                    "button",
                    {
                      staticClass: "ui right labeled icon violet tiny button",
                      staticStyle: {
                        padding: "8px 0px",
                        "margin-bottom": "2px"
                      },
                      on: { click: _vm.clickedLearnMore }
                    },
                    [
                      _c("i", { staticClass: "icon right arrow" }),
                      _vm._v("Learn more…")
                    ]
                  )
                ]),
                _c("hr")
              ]),
              _c("div", { staticClass: "information-panel" }, [
                _c("br"),
                _c("h2", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.infoUrl,
                      expression: "!infoUrl"
                    }
                  ],
                  staticClass: "noSelection",
                  domProps: { innerHTML: _vm._s(_vm.infoTitle) }
                }),
                _c(
                  "h2",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.infoUrl,
                        expression: "infoUrl"
                      }
                    ],
                    staticClass: "clickableLink"
                  },
                  [
                    _c(
                      "a",
                      { attrs: { target: "_blank", href: _vm.infoUrl } },
                      [_vm._v(_vm._s(_vm.infoTitle))]
                    )
                  ]
                ),
                _c("p", [_vm._v(" " + _vm._s(_vm.infoDetails))]),
                !_vm.infoUrl
                  ? _c(
                      "h3",
                      { staticStyle: { "text-align": "center" } },
                      [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.helptext.PRETEXT) }
                        }),
                        _c(
                          "router-link",
                          { attrs: { to: _vm.helptext.LINK_URL } },
                          [
                            _c("span", {
                              staticStyle: { color: "#fc4" },
                              domProps: {
                                innerHTML: _vm._s(_vm.helptext.LINK_TEXT)
                              }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm.is_map
                ? _c("div", { attrs: { id: "bottom-panel" } }, [
                    _c("div", { staticClass: "pickers" }, [
                      _c("div", { staticClass: "details-link" }, [
                        _vm.infoUrl
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "ui button small basic pink compact",
                                staticStyle: { float: "left" },
                                on: { click: _vm.clearMap }
                              },
                              [_vm._v("Clear Map")]
                            )
                          : _vm._e(),
                        _vm.infoUrl
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "ui button small right pink compact",
                                staticStyle: {
                                  float: "right",
                                  "margin-right": "0px"
                                },
                                on: { click: _vm.clickedMoreDetails }
                              },
                              [_vm._v("More Details…")]
                            )
                          : _vm._e()
                      ]),
                      _c("hr"),
                      _c("h5", [_vm._v("STATUS:")]),
                      _c(
                        "button",
                        {
                          staticClass: "tiny ui grey button",
                          class: {
                            active: _vm.filterUnderway,
                            yellow: _vm.filterUnderway
                          },
                          attrs: { id: "btn-underway" },
                          on: { click: _vm.clickedFilter }
                        },
                        [_vm._v("Underway")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "tiny ui grey button",
                          class: {
                            active: _vm.filterComplete,
                            yellow: _vm.filterComplete
                          },
                          attrs: { id: "btn-complete" },
                          on: { click: _vm.clickedFilter }
                        },
                        [_vm._v("Completed")]
                      ),
                      _c("h5", [_vm._v("CATEGORY:")]),
                      _c(
                        "button",
                        {
                          staticClass: "tiny ui grey button",
                          class: {
                            active: _vm.filterTransit,
                            blue: _vm.filterTransit
                          },
                          attrs: { id: "btn-transit" },
                          on: { click: _vm.clickedFilter }
                        },
                        [_vm._v("Transit")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "tiny ui grey button",
                          class: {
                            active: _vm.filterStreets,
                            green: _vm.filterStreets
                          },
                          attrs: { id: "btn-streets" },
                          on: { click: _vm.clickedFilter }
                        },
                        [_vm._v("Streets")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "tiny ui grey button",
                          class: {
                            active: _vm.filterAreas,
                            yellow: _vm.filterAreas
                          },
                          attrs: { id: "btn-areas" },
                          on: { click: _vm.clickedFilter }
                        },
                        [_vm._v("Plans & Programs")]
                      ),
                      _c("div", { attrs: { id: "dropdowns" } }, [
                        _c(
                          "div",
                          {
                            staticClass: "narrow-dropdown",
                            staticStyle: { float: "left" }
                          },
                          [
                            _c("h5", [_vm._v("DISTRICT:")]),
                            _c(
                              "div",
                              { staticClass: "ui selection fluid dropdown" },
                              [
                                _c("div", { staticClass: "text" }, [
                                  _c("div", {}, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.nameOfFilterDistrict(
                                          _vm.filterDistrict
                                        )
                                      )
                                    )
                                  ])
                                ]),
                                _c("i", { staticClass: "dropdown icon" }),
                                _c(
                                  "div",
                                  { staticClass: "menu" },
                                  _vm._l(
                                    [-1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                                    function(i) {
                                      return _c(
                                        "div",
                                        {
                                          staticClass: "item",
                                          on: {
                                            click: function($event) {
                                              return _vm.clickedDistrict(i)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.nameOfFilterDistrict(i))
                                          )
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "narrow-dropdown",
                            staticStyle: { float: "right" }
                          },
                          [
                            _c("h5", [_vm._v("FUNDING SOURCE:")]),
                            _c(
                              "div",
                              { staticClass: "ui selection fluid dropdown" },
                              [
                                _c("div", { staticClass: "text" }, [
                                  _c("div", {}, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.filterFund
                                          ? _vm.filterFund
                                          : "All sources…"
                                      )
                                    )
                                  ])
                                ]),
                                _c("i", { staticClass: "dropdown icon" }),
                                _c(
                                  "div",
                                  { staticClass: "menu" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "item",
                                        attrs: { "data-fund": null },
                                        on: { click: _vm.clickedFunds }
                                      },
                                      [_vm._v("All sources")]
                                    ),
                                    _vm._l(_vm.fundSources, function(fund) {
                                      return _c(
                                        "div",
                                        {
                                          staticClass: "item",
                                          attrs: { "data-fund": fund },
                                          on: { click: _vm.clickedFunds }
                                        },
                                        [_vm._v(_vm._s(fund))]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _c("div", { staticClass: "make-some-space" }),
              _vm._m(1)
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "apptitle" }, [
      _c("a", { attrs: { href: "/" } }, [_vm._v("MyStreetSF")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "table-logo" } }, [
      _c(
        "a",
        {
          staticClass: "agency-link",
          attrs: { target: "_blank", href: "https://www.sfcta.org/" }
        },
        [
          _c("img", {
            staticClass: "img-logo",
            attrs: { src: require("../assets/sfcta-logo.png") }
          })
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-055d797f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-055d797f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyStreet.vue
// module id = null
// module chunks = 